<template>
	<div>
		<v-container fluid pa-0>
			<v-card elevation="0">
				<v-container fluid grid-list-xl class="toolbar-container">
					<v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
						<v-toolbar color="transparent" flat elevation="0">
							<v-toolbar-title class="ml-0"
								>{{ $t($route.meta.title) }}</v-toolbar-title>
							<v-spacer></v-spacer>
						</v-toolbar>
					</v-layout>
				</v-container>

				<v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
					<v-card class="mx-auto mt-3" flat>
						<v-card-text class="pa-0">
							<v-layout row wrap>
								<v-flex xs12 sm3 md2 pa-0>
									<v-layout inner-layout column fill-height style="gap: 8px" class="mr-3">
										<v-list-tile
											v-for="(item, i) in group_options"
											v-if="!item.permission || hasPerm(item.permission)"
											:key="i"
											@click="current_active != i ? $router.push({ name: 'configuration', params: { tab: i > 0 ? i : null } }) : ''"
											class="br-7 pa-2 permission-login-type-hover"
											:style="{
												cursor: 'pointer',
												backgroundColor: current_active == i ? primaryColor : 'rgba(0,0,0,0.1)',
												color: current_active == i ? 'white' : 'black',
											}"
										>
											<v-list-tile-title>
												<v-list-tile-title
													><v-icon class="mr-3">{{ item.icon }}</v-icon
													>{{ item.text | capitalize }}</v-list-tile-title
												>
											</v-list-tile-title>
										</v-list-tile>
										<!-- <v-flex grow hidden-xs-only border border-left-0 border-top-0 border-bottom-0 unselectable pb-0> &nbsp; </v-flex> -->
									</v-layout>
								</v-flex>
								<v-flex xs12 sm9 md10>
									<div class="h-100">
										<v-layout row wrap class="pa-3 br-7 c-border background-white">
											<v-flex xs12 text-center>
												<v-layout row wrap inner-layout pb-2>
													<v-flex xs12 fs-22 text-uppercase>
														{{ group_options[current_active].text }}
													</v-flex>
													<v-flex xs12 fs-14 pb-2 grey--text>
														{{ group_options[current_active].description }}
													</v-flex>
												</v-layout>
											</v-flex>
											<!-- Display if the current group has fetched data -->
											<v-flex xs12 sm6 md4 v-for="(x, i) in current_group_fetched_data" :key="i" pb-3 v-if="current_group_fetched_data">
												<!-- This v-card is a custom implementation for the API integrations feature. Any new modules will need additional v-cards-->
												<v-card
													class="mx-2 my-1 secondary-hover clickable border rounded br-7 white-bg"
													flat
													min-width="130"
													height="80"
													@mouseup.left="$router.push(`oauth/providers/${x.third_party}`)"
													v-if="x.third_party && x.service_name"
												>
													<v-layout row align-center justify-center class="h-100 pa-2">
														<v-flex class="text-center">
															<v-img style="scale: 0.6" v-if="x.logo" :src="x.logo"></v-img>
															<div v-else>{{ x.service_name }}</div>
														</v-flex>
													</v-layout>
												</v-card>
											</v-flex>
											<!-- Display if the current group does not have fetched data and only uses options -->
											<v-flex xs12 sm6 md4 v-for="(x, i) in current_group" :key="i" pb-3>
												<v-card
													class="mx-2 my-1 secondary-hover clickable border rounded br-7 white-bg"
													flat
													min-width="130"
													height="80"
													@mouseup.left="$router.push({ name: x.link })"
												>
													<v-layout row class="mt-3 unselectable">
														<v-flex xs2>
															<v-icon>{{ x.icon }}</v-icon>
														</v-flex>
														<v-flex xs10 style="font-size: 16px">
															<v-layout row wrap inner-layout>
																<v-flex xs12 fw-bold>
																	{{ $t(`lang.${x.text}`) }}
																</v-flex>
																<v-flex xs12 fs-14>
																	{{ x.description }}
																</v-flex>
															</v-layout>
														</v-flex>
													</v-layout>
												</v-card>
											</v-flex>
										</v-layout>
									</div>
								</v-flex>
							</v-layout>
						</v-card-text>
					</v-card>
				</v-card-text>
			</v-card>
		</v-container>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { store } from "Store/store";
import { configurationMenus } from "Modules/configuration/configuration_menu/menu.data";

export default {
	data() {
		return {
			group_options: configurationMenus,
			current_active: 0,
			mobile_list: [
				{ title: this.$t("lang.add_new"), action: "showMachine" },
				{ title: this.$t("lang.refresh"), action: "dbGetMachines" },
			],
			oauth_providers: [],
		};
	},
	beforeRouteEnter(to, from, next) {
		next((vm) => {
			vm.current_active = to.params.tab ? to.params.tab : 0;
			vm.finishLoader();
		});
	},
	beforeRouteUpdate(to, from, next) {
		this.finishLoader();
		this.current_active = to.params.tab ? to.params.tab : 0;
		next();
	},
	computed: {
		current_group() {
			return this.group_options[this.current_active].options;
		},
		current_group_fetched_data() {
			const group = this.group_options[this.current_active];
			const key = group.fetched_data_key;
			return group.fetched_data ? group.fetched_data[key] : [];
		},
		primaryColor() {
			// For Vuetify 1.5, the theme structure is different
			if (this.$vuetify && this.$vuetify.theme) {
				return this.$vuetify.theme.primary || "#2A4C8E";
			}
			return "#2A4C8E"; // Fallback color
		},
	},
	methods: {
		async fetchDataForGroupOptions() {
			// Iterate over group_options to find items with a fetch property
			const fetchPromises = this.group_options.map(async (group) => {
				if (group.fetch) {
					try {
						// Dispatch the Vuex action dynamically
						const data = await this.$store.dispatch(group.fetch, {});

						// Map the fetched data back to the group
						this.$set(group, "fetched_data", data); // Use Vue's $set to ensure reactivity
					} catch (error) {
						console.error(`Error fetching data for group "${group.text}":`, error);
					}
				}
			});

			// Wait for all fetch actions to complete
			await Promise.all(fetchPromises);
		},
	},
	mounted() {
		this.fetchDataForGroupOptions();
	},
};
</script>
<style>
i.hgi {
	display: inline-flex !important;
}
</style>
